import { useAddFavoriteGame, useDeleteFavoriteGame } from 'react-easyrocket';
import { StoreType } from './types.ts';

export const getFavoriteState = (
  id: number | undefined,
  store: StoreType,
  defaultState: boolean | undefined
) => {
  if (id === undefined) return Boolean(defaultState);

  const storeValue = store.mainStore.get(id);

  if (storeValue === undefined) return Boolean(defaultState);

  return storeValue;
};

export const getRequestFunctionByCurrentState = (
  currentState: boolean,
  addRequest: ReturnType<typeof useAddFavoriteGame>['mutateAsync'],
  deleteRequest: ReturnType<typeof useDeleteFavoriteGame>['mutateAsync']
) => {
  return currentState ? deleteRequest : addRequest;
};
